import {
    makeStyles,
    createStyles,
    Theme,
    useTheme,
} from '@material-ui/core/styles'

export default makeStyles((theme: Theme) =>
    createStyles({
        wrapper: {
            height: 560,
            borderRadius: 4,
            width: '100%',
            overflow: 'hidden',
            [theme.breakpoints.down('md')]: {
                height: 403,
            },
            [theme.breakpoints.down('sm')]: {
                height: 432,
                borderRadius: 0,
            },
            '& video': {
                outline: 'none',
            },
        },
        playIcon: {
            width: 64,
            height: 64,
        },
    })
)
